/* eslint-disable no-shadow */
export enum MetaTagAttr {
  name = 'name',
  property = 'property'
}

export interface IMetaTag {
  attr: MetaTagAttr;
  attrValue: string;
  value?: string;
}
